function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */


import Base from './base'; // @namespace Model

var Vote = /*#__PURE__*/function (_Base) {
  _inheritsLoose(Vote, _Base);

  function Vote() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = Vote.prototype;

  _proto.url = function url() {
    return '/vote.json';
  };

  return Vote;
}(Base);

export default Vote;